import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { useHelpCategories } from '../../api/help-categories';
import { COLORS, ROUTES } from '../../config/constants';
import MenuSection from './components/section';
import './Menu.scss';

const Menu = () => {

    const { t } = useTranslation()
    const location = useLocation()
    const categories = useHelpCategories()

    return (
        <div className='menu-list'>
            <List
                sx={{
                    width: '100%',
                    paddingTop: 0,
                }}
                component='nav'
            >
                <ListItemButton
                    component={Link}
                    to={ROUTES.HOME}
                    sx={{
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        color: 'inherit',
                        textDecoration: 'none',
                        '&.MuiButtonBase-root': {
                            height: '44px',
                            minHeight: '44px',
                        },
                        ...(location.pathname === ROUTES.HOME && {
                            backgroundColor: COLORS.LIGHT_BLUE,
                        }),
                    }}
                >
                    <ListItemText
                        primary={t('common__text__mainPage')}
                        sx={{
                            paddingLeft: 1,
                            marginTop: 0,
                            marginBottom: 0,
                        }}
                    />
                </ListItemButton>
                {categories.map((category) => {
                    const categoryPath = `/${category.slug}`

                    return (
                        <MenuSection
                            key={category.documentId}
                            title={category.name}
                            to={categoryPath}
                            isActive={location.pathname === categoryPath}
                        />
                    )
                })}
            </List>
        </div>
    )
}

export default Menu
